import {
  GET_REIMBURSEMENT,
  GET_REIMBURSEMENT_SUCCESS,
  GET_REIMBURSEMENT_FAIL,
  DELETE_REIMBURSEMENT,
  DELETE_REIMBURSEMENT_SUCCESS,
  DELETE_REIMBURSEMENT_FAIL,
  UPDATE_REIMBURSEMENT,
  UPDATE_REIMBURSEMENT_SUCCESS,
  UPDATE_REIMBURSEMENT_FAIL,
  ADD_NEW_REIMBURSEMENT,
  ADD_REIMBURSEMENT_SUCCESS,
  ADD_REIMBURSEMENT_FAIL,
  REIMBURSEMENT_LOADING,
  REIMBURSEMENT_RESET,
} from "./actionType";

export const resetReimbursementState = (actionType) => ({
  type: REIMBURSEMENT_RESET,
  payload: { actionType },
});

export const getReimbursementSuccess = (actionType, data) => ({
  type: GET_REIMBURSEMENT_SUCCESS,
  payload: { actionType, data },
});

export const getReimbursementFail = (actionType, error) => ({
  type: GET_REIMBURSEMENT_FAIL,
  payload: { actionType, error },
});

export const getReimbursement = data => ({
  type: GET_REIMBURSEMENT,
  payload: data,
});

export const getReimbursementLoading = () => ({
  type: REIMBURSEMENT_LOADING
});

export const deleteReimbursement = data => ({
  type: DELETE_REIMBURSEMENT,
  payload: data,
});

export const deleteReimbursementSuccess = data => ({
  type: DELETE_REIMBURSEMENT_SUCCESS,
  payload: data,
});

export const deleteReimbursementFail = error => ({
  type: DELETE_REIMBURSEMENT_FAIL,
  payload: error,
});

export const updateReimbursement = data => ({
  type: UPDATE_REIMBURSEMENT,
  payload: data,
});

export const updateReimbursementFail = error => ({
  type: UPDATE_REIMBURSEMENT_FAIL,
  payload: error,
});

export const updateReimbursementSuccess = data => ({
  type: UPDATE_REIMBURSEMENT_SUCCESS,
  payload: data,
});

export const addNewReimbursement = data => ({
  type: ADD_NEW_REIMBURSEMENT,
  payload: data,
});

export const addReimbursementSuccess = data => ({
  type: ADD_REIMBURSEMENT_SUCCESS,
  payload: data,
});

export const addReimbursementFail = error => ({
  type: ADD_REIMBURSEMENT_FAIL,
  payload: error,
});